import { SkeletonBox, SkeletonText, SkeletonCircle } from '../primitives';
import '../primitives/Skeletons.css';

const SidebarSkeleton = () => {
  return (
    <aside className="skeleton-sidebar" aria-hidden="true">
      {/* Header */}
      <div className="skeleton-sidebar__header">
        <SkeletonText widths={['120px']} lineHeight="24px" />
        <SkeletonCircle size={32} />
      </div>

      {/* Primary nav items */}
      <nav className="skeleton-sidebar__nav">
        <div className="skeleton-sidebar__nav-item">
          <SkeletonCircle size={20} />
          <SkeletonText widths={['80px']} lineHeight="16px" />
        </div>
        <div className="skeleton-sidebar__nav-item">
          <SkeletonCircle size={20} />
          <SkeletonText widths={['70px']} lineHeight="16px" />
        </div>
      </nav>

      {/* Decks section */}
      <div className="skeleton-sidebar__section">
        <div className="skeleton-sidebar__section-title">
          <SkeletonText widths={['60px']} lineHeight="12px" />
        </div>
        <div className="skeleton-sidebar__list">
          {[1, 2, 3, 4, 5].map((item) => (
            <div key={item} className="skeleton-sidebar__list-item">
              <SkeletonCircle size={16} />
              <SkeletonText
                widths={[`${60 + (item % 3) * 20}px`]}
                lineHeight="14px"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Footer */}
      <div className="skeleton-sidebar__footer">
        <SkeletonBox height={40} borderRadius="var(--radius-md)" />
        <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-sm)', marginTop: 'var(--space-md)' }}>
          <SkeletonCircle size={36} />
          <div style={{ flex: 1 }}>
            <SkeletonText widths={['80px']} lineHeight="14px" />
            <SkeletonText widths={['100px']} lineHeight="12px" style={{ marginTop: '4px' }} />
          </div>
        </div>
      </div>
    </aside>
  );
};

export default SidebarSkeleton;
